export default "__VITE_ASSET__269a6b6c__"